import React from 'react';
import { Button, Col, Form, FormGroup, Label, Modal } from 'reactstrap';


const CategoryModal = ({ handleCategoryClick, categoryModal, setCategoryModal, handleCategorySubmit }) => {

    
   

    return (
        <div>

            <Modal isOpen={categoryModal} fade={false} handleCategoryClick={handleCategoryClick}>
                <div className='text-center border p-4 fw-bold'>Category Add </div>

                <div className="row p-2">
                    <div className="col-md-12">
                        <Form  onSubmit={handleCategorySubmit}>

                        <FormGroup>
                                <Label for="exampleName">
                                    Category Name
                                </Label>
                                <input required className="form-control"  name='category_name' />
                                
                            </FormGroup>
                            <FormGroup className='d-none'>
                                <Label for="exampleName">
                                    status
                                </Label>
                                <input defaultValue={1} required className="form-control"  name='status' />
                                
                            </FormGroup>

                            <FormGroup row>
                                <Label
                                    for="exampleText"
                                >
                                    Description
                                </Label>
                                <Col>

                                    <textarea
                                        name='description'
                                        type="textarea"
                                        className="form-control"
                                    />
                                </Col>
                               
                            </FormGroup>

                            <Button className='w-100' color="primary" type='submit' >
                                Save
                            </Button>
                           
                        </Form>
                    </div>
                </div>

                <div className=' p-2'>
                    <Button className='w-100' onClick={handleCategoryClick}>
                        Close
                    </Button>
                </div>

            </Modal>
        </div>
    );
};

export default CategoryModal;